export default __webpack_public_path__ + "static/spiritual-india-places-4-f5d8bb16b532e842c625d481338c1f69.jpg";